import { DOCUMENT } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { DrupalService } from '@app/services/drupal.service';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { MobiLdSchemaComponent } from '@app/components/mobi-ld-schema/mobi-ld-schema.component';

@Component({
  selector: 'mobi-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [ComponentSharedModule, MobiUiIconComponent, MobiLdSchemaComponent],
  standalone: true,
})
export class BreadcrumbComponent {
  #drupal = inject(DrupalService);
  #doc = inject(DOCUMENT);

  breadcrumb = this.#drupal.breadcrumb;

  schema = computed(() => {
    const { protocol, hostname } = this.#doc.location;
    const origin = `${protocol}//${hostname}`;
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: this.breadcrumb()?.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: index === 0 ? 'Home' : item.title,
        item: origin + item.url.path,
      })),
    };
  });
}
